import type { IProposal } from "../../../../types/models/proposals.modals.types";
import { useGetHttp } from "../../http.hook";

interface IResponse {
  proposals: Array<IProposal>;
}

export function useGetAllProposalsAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/campaigns/proposals",
  });
}
